import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

const INITIAL_RESEND_TIMER = 600;
const initialState = {
  resendVerificationTimer: INITIAL_RESEND_TIMER,
  ssoLogin: false
};

let store = set => ({
  ...initialState,
  loadResendVerificationTimer: () => {
    set(() => ({
      resendVerificationTimer: INITIAL_RESEND_TIMER
    }));
  },
  updateResendVerificationTimer: resendVerificationTimer => {
    set(() => ({
      resendVerificationTimer
    }));
  },
  updateSsoLogin: ssoLogin => {
    set(() => ({
      ssoLogin
    }));
  },
  reset: () => set(initialState)
});

store = persist(store, {
  name: 'auth',
  storage: createJSONStorage(() => sessionStorage)
});
export const useAuthStore = create(devtools(store));
